import { type FC } from 'react';
import StorageIcon from '@assets/img/icons/storage-small.svg?react';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type GoodsType } from '@common/types/goods';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import { StringXSmall } from '@components/Typography/Typography';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import css from './styles.module.scss';

interface StorageIndicatorProps {
  resource: ResourceTypeText | PlantTypeText | GoodsType;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

const StorageIndicator: FC<StorageIndicatorProps> = ({
  resource,
  className,
  iconClassName,
  textClassName,
}) => {
  const storage = useAppSelector((state) => state.user.user?.storage);

  return (
    <div className={cn(css.storageIndicator, className)}>
      <StorageIcon className={cn('text-white/80', iconClassName)} />
      <StringXSmall weight="bold" className={cn('text-white', textClassName)}>
        {storage && storage[resource]
          ? toShortNumFormat(storage[resource].value)
          : 0}
      </StringXSmall>
    </div>
  );
};

export { StorageIndicator };
